import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber'

const phoneUtil = PhoneNumberUtil.getInstance()

/**
 * Validates a complete phone number.
 *
 * @param fullNumber - Complete number, including the country code (e.g., "+5511998765432").
 * @param countryIsoCode - ISO country code (e.g., "BR" for Brazil).
 * @returns An object indicating if the number is valid, along with additional information.
 */
export const validatePhoneNumber = (
  fullNumber: string,
  countryIsoCode: string,
) => {
  try {
    // Attempts to parse the full number with the country code
    const phoneNumber = phoneUtil.parse(fullNumber, countryIsoCode)

    // Checks if the number is valid
    const isValid = phoneUtil.isValidNumber(phoneNumber)

    if (!isValid) {
      return {
        isValid: false,
        error: 'Invalid number for the specified country.',
      }
    }

    // Returns the formatted number and extra information
    return {
      isValid: true,
      formattedNumber: phoneUtil.format(
        phoneNumber,
        PhoneNumberFormat.INTERNATIONAL,
      ), // International format
      nationalFormat: phoneUtil.format(phoneNumber, PhoneNumberFormat.NATIONAL), // National format
      countryCode: phoneNumber.getCountryCode(), // Country code (e.g., 55 for Brazil)
      regionCode: phoneUtil.getRegionCodeForNumber(phoneNumber), // Detected ISO country code
    }
  } catch (error: any) {
    // If parsing fails, returns the error
    return { isValid: false, error: error?.message }
  }
}
